// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "style/2c1forest/" + chunkId + ".bundle.css"; };